export enum MessageType {
  GET_PERMIT = 'GET_PERMIT',
  GET_PERMIT_FOR_TAB = 'GET_PERMIT_FOR_TAB',
  STORE_PERMIT = 'STORE_PERMIT',
  GET_PERMIT_RESPONSE = 'GET_PERMIT_RESPONSE',
  GET_AI_FIELD_MAPPING = 'GET_AI_FIELD_MAPPING',
  FETCH_PERMIT_TO_PREFILL = 'FETCH_PERMIT_TO_PREFILL',
  INITIALIZE_PANEL_FROM_PERMIT_ID = 'INITIALIZE_PANEL_FROM_PERMIT_ID',
  REPORT_INVALID_MATCHING = 'REPORT_INVALID_MATCHING',
  REPORT_MISSING_MATCHING = 'REPORT_MISSING_MATCHING',
  INITIALIZE_EXTENSION = 'INITIALIZE_EXTENSION',
  LOGIN = 'LOGIN',
  PREFILL_PAGE = 'PREFILL_PAGE',
  PREFILL_TAB = 'PREFILL_TAB',
  GET_UI_MODE = 'GET_UI_MODE',
  SET_UI_MODE = 'SET_UI_MODE',
  GET_SIDE_PANEL_STATE = 'GET_SIDE_PANEL_STATE',
  SET_SIDE_PANEL_STATE = 'SET_SIDE_PANEL_STATE',
  GET_SESSION_PERMISSIONS = 'GET_SESSION_PERMISSIONS',
}
